module.exports = __webpack_public_path__ + "static/media/hesham.6d05dfcc.png";